import type { GeneralApiError } from "@/api/custom_types";
import { useTranslation } from "@/hooks";
import { ApiError } from "./fetching";
import type { TranslationKey } from "./type-utils";

export const RefreshTokenAPIErrorHandler = (
	response: Response,
	errorSchema: GeneralApiError,
): string => {
	const { t } = useTranslation();
	if ("type" in errorSchema === false) {
		throw new ApiError("Error type is missing in the response", response);
	}

	const errorType = errorSchema?.type;
	if (errorType === undefined) {
		throw new ApiError("errorType is undefined", response);
	}

	return t(`openApi.error.${errorType}` as TranslationKey);
};
